import React from "react";

function TripQueues() {
  return <div>TripQueues</div>;
}

export default TripQueues;
